import * as React from 'react'
import Link from 'gatsby-link'
import { Element } from 'react-scroll'
import * as classnames from 'classnames'

import Container from '../Container'
import Row from '../Row'
import Col from '../Col'
import FullScreenSection from '../FullScreenSection'
import UnsplashCreditBadge from '../UnsplashCreditBadge'

import * as styles from '../Features/Features.module.scss'

const About = () => (
  <FullScreenSection name="about">
    <Container>
      <div className={styles.featureFullscreenBackground}>
        <div className={styles.credit}>
          <UnsplashCreditBadge
            src="https://unsplash.com/@stairhopper?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge"
          >
          Alex Holyoake
          </UnsplashCreditBadge>
        </div>
        <Row>
          <Col>
            <div className={styles.innerBox}>
              <h2>Contact me</h2>
              <Row>
                <Col>
                  <h3>Email</h3>
                  <a href="mailto:hello@mroth.io">hello@mroth.io</a>
                </Col>
                <Col>
                  <h3>LinkedIn</h3>
                  <a href="https://www.linkedin.com/in/moritzroth/">@moritzroth</a>
                </Col>
                <Col>
                  <h3>GitHub</h3>
                  <a href="https://www.github.com/mroth23/">@mroth23</a>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  </FullScreenSection>
)

export default About



// WEBPACK FOOTER //
// ./src/components/About/About.tsx